var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.4 96c-22.06 0-40 17.94-40 40V240c0 4.406-3.594 8-8.141 8c-4.406 0-8-3.594-8-8V72c0-22.06-17.94-40-40-40s-40 17.94-40 40L320 240c0 4.406-3.425 8-7.831 8s-8-3.594-8-8V40c0-22.06-18.06-40-40.12-40S224.2 17.94 224.2 40L224.1 240c0 4.406-3.448 8-7.854 8S208.1 244.4 208.1 240l.1092-168c0-22.06-18.04-40-40.11-40S128.2 49.94 128.2 72v252.9L79.89 277.2C71.05 268.4 59.11 263.5 46.53 263.5c-10.48 0-45.82 8.397-45.82 45.91c0 12.73 5.001 25.69 14.75 35.44l107.9 108.1C161.3 491 211.8 512 265.6 512h62.73c92.64 0 168-75.36 168-168v-208C496.4 113.9 478.4 96 456.4 96zM480.4 344c0 83.81-68.19 152-152 152h-62.73c-49.5 0-96.03-19.3-131-54.34l-107.9-108.1c-6.67-6.679-10.11-15.51-10.11-24.1c0-18.88 15.92-29.95 30.2-29.95c8.109 0 15.94 3.234 21.73 9.062l62 61.14c1.513 1.503 3.542 2.291 5.607 2.291c4.521 0 8.018-3.648 8.018-7.994v-272c0-13.23 10.77-24 24-24s24 10.77 24 24L192.1 240c0 13.23 10.91 24 24.15 24S240.1 253.2 240.1 240l.1093-200c0-13.23 10.77-24 24-24s24 10.77 24 24L288 240c0 13.23 10.94 24 24.17 24s24-10.77 24-24V72c0-13.23 10.77-24 24-24s24 10.77 24 24L384.1 240c0 13.23 10.91 24 24.29 24c13.23 0 24-10.77 24-24V136c0-13.23 10.77-24 24-24s24 10.77 24 24V344z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPaper);
export default __webpack_public_path__ + "static/media/hand-paper.f0cde330.svg";
export { ForwardRef as ReactComponent };